import Persona, { Client, ClientOptions } from 'persona';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { Loader } from 'semantic-ui-react';

import { logErrorService } from '../../shared/services';

interface SignInProps {
  handleBiometricSignIn: (inquiryId: string) => void;
  handleBiometricCancel: () => void;
  initialInquiryId: string;
}

const BiometricSignInContentWithoutIntl = ({
  handleBiometricSignIn,
  handleBiometricCancel,
  initialInquiryId,
  intl,
}: SignInProps & InjectedIntlProps) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let client: Client;
    let destroyed = false;
    const destroyClient = () => {
      if (client && !destroyed) {
        destroyed = true;
        client.destroy();
      }
    };

    const logFinished: ClientOptions['onComplete'] = ({ inquiryId, status, fields }) => {
      handleBiometricSignIn(inquiryId);
      destroyClient();
    };

    const onReady = () => {
      setIsLoading(false);
      client.open();
    };

    const onCancel = () => {
      handleBiometricCancel();
    };

    client = new Persona.Client({
      inquiryId: initialInquiryId,
      environment: 'production',
      onReady: onReady,
      onComplete: logFinished,
      onCancel: onCancel,
      onError: logErrorService,
    });

    return destroyClient;
  }, []);

  return (
    <div className="auth__container--persona">
      {isLoading && <Loader className="persona-loader" active={true} inline="centered" size="massive" />}
    </div>
  );
};

export const BiometricSignIn = injectIntl(BiometricSignInContentWithoutIntl);
